import React from "react";
import { View, Text, Dimensions } from "react-native";
import { widthPercentageToDP as wp } from "react-native-responsive-screen";
import { BackButton } from "app/components/common";
import theme from "app/Theme/Theme";

const { width } = Dimensions.get("window");

const Header = ({ title, navigation, testID = undefined }) => {
  const onPressBack = () => {
    navigation.goBack();
  };

  return (
    <View style={styles.main}>
      <View style={styles.leftView}>
        <BackButton
          onPress={onPressBack}
          style={styles.backIcon}
          testID={testID}
        />
      </View>
      <View style={styles.middleView}>
        <Text style={styles.text}>{title}</Text>
      </View>
      <View style={styles.rightView} />
    </View>
  );
};

Header.defaultProps = {
  title: "Mes Amis",
};

const styles = {
  main: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width,
  },
  leftView: {
    alignItems: "flex-start",
    justifyContent: "center",
    flex: 1,
  },
  backIcon: {
    marginLeft: 25,
  },
  middleView: {
    alignItems: "center",
    justifyContent: "center",
    flex: 3,
  },
  rightView: {
    alignItems: "flex-end",
    justifyContent: "center",
    flex: 1,
  },
  text: {
    color: theme.colors["neutral.900"],
    fontWeight: "bold",
    fontSize: wp("5%"),
  },
};

export default Header;
